export default __webpack_public_path__ + "static/media/ph-15.a31519f1.jpg";